export default {
  tabCluster: '集群设备配置',
  tabScene: '应用场景配置',

  add: '新增',
  edit: '修改',
  delete: '删除',
  cancel: '取消',
  confirm: '确定',
  operation: '操作',
  image: '图片',
  createTime: '创建时间',
  updateTime: '更新时间',

  deleteConfirmTitle: '确认删除',
  deleteConfirmContent: '是否删除"{name}"?',
  deleteConfirm: '删除',
  deleteSuccess: '删除成功',
  addSuccess: '新增成功',
  editSuccess: '修改成功',

  selectImage: '选择图片',
  imageRequired: '请上传图片',

  cluster: {
    addTitle: '新增集群设备',
    editTitle: '修改集群设备',
    deviceType: '设备类型',
    deviceTypePlaceholder: '请选择设备类型',
    deviceTypeRequired: '请选择设备类型',
    name: '设备名称',
    namePlaceholder: '请输入设备名称',
    nameRequired: '请输入设备名称',
    nameEn: '设备英文名称',
    nameEnPlaceholder: '请输入设备英文名称',
    nameEnRequired: '请输入设备英文名称',
    status: '状态',
    statusPlaceholder: '请选择状态',
    statusRequired: '请选择状态',
    statusNormal: '正常',
    statusDisabled: '停用',
    online: '在线状态',
    onlinePlaceholder: '请选择在线状态',
    onlineRequired: '请选择在线状态',
    onlineYes: '在线',
    onlineNo: '离线',
    address: '地址',
    addressPlaceholder: '请输入地址',
    addressRequired: '请输入地址',
    addressEn: '英文地址',
    addressEnPlaceholder: '请输入英文地址',
    addressEnRequired: '请输入英文地址',
    deviceTypeCol: '设备类型',
    addressCol: '地址',
  },

  scene: {
    addTitle: '新增应用场景',
    editTitle: '修改应用场景',
    name: '场景名称',
    namePlaceholder: '请输入场景名称',
    nameRequired: '请输入场景名称',
    nameEn: '英文名称',
    nameEnPlaceholder: '请输入英文名称',
    nameEnRequired: '请输入英文名称',
    description: '描述',
    descriptionPlaceholder: '请输入描述',
    descriptionRequired: '请输入描述',
    descriptionEn: '英文描述',
    descriptionEnPlaceholder: '请输入英文描述',
    descriptionEnRequired: '请输入英文描述',
    label: '标签',
    labelPlaceholder: '多个标签用英文逗号分隔',
    labelRequired: '请输入标签',
    labelEn: '英文标签',
    labelEnPlaceholder: '多个标签用英文逗号分隔',
    labelEnRequired: '请输入英文标签',
    sort: '排序',
    sortPlaceholder: '请输入排序值',
    sortRequired: '请输入排序值',
    webUrl: '网页链接',
    webUrlPlaceholder: '请输入网页链接',
  },
}
